import { Alert, Snackbar } from '@mui/material';
import { TickCircle, CloseCircle } from 'iconsax-react';
import { useState } from 'react';

interface IAlert {
  message?: string;
  type?: 'success' | 'error';
  isAlert: boolean;
}

interface IAppAlert {
  onClose: () => void;
  alert: IAlert;
}

export const AppAlert = (props: IAppAlert) => {
  return (
    <Snackbar
      open={props.alert.isAlert}
      autoHideDuration={6000}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'top',
      }}
      onClose={props.onClose}
      sx={{
        minWidth: 300,
        bgcolor: 'background.default',
        borderRadius: 3,
      }}
    >
      <Alert
        onClose={props.onClose}
        severity={props.alert.type}
        sx={{ width: '100%' }}
        variant='outlined'
        iconMapping={{
          success: <TickCircle size='20' variant='Bold' />,
          error: <CloseCircle size='20' variant='Bold' />,
        }}
      >
        {props.alert.message}
      </Alert>
    </Snackbar>
  );
};

export default function useAlert() {
  const [alertState, setAlertState] = useState<IAlert>({
    isAlert: false,
    message: 'Something went wrong',
    type: 'error',
  });

  const onCloseAlert = () => {
    setAlertState((pre) => ({
      isAlert: !pre.isAlert,
      message: pre.message,
      type: pre.type,
    }));
  };
  return {
    alertState,
    setAlertState,
    onCloseAlert,
  };
}
